import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const TypeWriter = () => {
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const words = ["Business Owners Like You", "Individuals Like You"];
  const period = 2000;
  const [delta, setDelta] = useState(100);

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => clearInterval(ticker);
  }, [text]);

  const tick = () => {
    let i = loopNum % words.length;
    let fullText = words[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(100);
    }
  };

  return <span>{text}</span>;
};

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const slides = [
    {
      videoUrl: "/videos/video_1_Tax_Solution.mp4",
    },
    {
      videoUrl: "/videos/video_2_Tax_Solution.mp4",
    },
    {
      videoUrl: "/videos/video_3_Tax_Solution.mp4",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  useEffect(() => {
    const videoContainer = document.querySelector(".video-container");

    const preventDefault = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    if (videoContainer) {
      videoContainer.addEventListener("touchstart", preventDefault, {
        passive: false,
      });
      videoContainer.addEventListener("touchmove", preventDefault, {
        passive: false,
      });
      videoContainer.addEventListener("touchend", preventDefault, {
        passive: false,
      });
      videoContainer.addEventListener("click", preventDefault);
    }

    return () => {
      if (videoContainer) {
        videoContainer.removeEventListener("touchstart", preventDefault);
        videoContainer.removeEventListener("touchmove", preventDefault);
        videoContainer.removeEventListener("touchend", preventDefault);
        videoContainer.removeEventListener("click", preventDefault);
      }
    };
  }, []);

  return (
    <div className="relative w-full overflow-hidden">
      <div className="relative h-[50vh] md:h-screen w-full">
        <div className="video-container absolute inset-0 bg-black/50">
          <div
            className="absolute inset-0 z-0 pointer-events-none select-none touch-none"
            style={{
              WebkitTouchCallout: "none",
              WebkitUserSelect: "none",
              KhtmlUserSelect: "none",
              MozUserSelect: "none",
              msUserSelect: "none",
              userSelect: "none",
            }}
          >
            <video
              key={slides[currentSlide].videoUrl}
              className="h-full w-full object-cover"
              autoPlay
              muted
              loop
              playsInline
              controls={false}
              playsinline="true"
              webkit-playsinline="true"
              controlsList="nodownload nofullscreen noremoteplayback"
              disablePictureInPicture
              style={{
                pointerEvents: "none",
                touchAction: "none",
              }}
            >
              <source src={slides[currentSlide].videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <div className="relative h-full flex items-center justify-end text-white px-4 md:px-16 pointer-events-auto">
          <div className="text-right mt-20">
            <div className="flex flex-col items-end gap-2">
              <h1 className="text-base md:text-7xl font-light">
                <span className="inline-block backdrop-blur-sm bg-gray-900/30 px-3 md:px-6 py-2 md:py-3 rounded-lg">
                  Accounting Services for
                </span>
              </h1>
              <h2 className="text-base md:text-7xl font-light">
                <span className="inline-block backdrop-blur-sm bg-gray-900/30 px-3 md:px-6 py-2 md:py-3 rounded-lg">
                  <TypeWriter />
                </span>
              </h2>
            </div>
            <button
              onClick={() => navigate("/contact")}
              className="bg-red-400 text-white px-6 md:px-10 py-2 md:py-4 rounded-lg text-base md:text-xl hover:bg-red-500 transition-colors inline-block mt-4 md:mt-8 font-light"
            >
              Book an Appointment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
